"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTextInput = exports.validateFormTextInput = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const BaseFormField = core_1.getComponent('BaseFormField');
const validateFormTextInput = (props) => (value) => {
    const { required, type } = props;
    let error;
    // If field is required
    if (required === true && !value) {
        error = 'This field is required';
    }
    // If field 'email'
    else if (type === 'email' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
        error = 'Please enter a valid email address';
    }
    return error;
};
exports.validateFormTextInput = validateFormTextInput;
const FormTextInput = (props) => {
    const [field, meta, helpers] = formik_1.useField(Object.assign(Object.assign({}, props), { validate: props.validate || exports.validateFormTextInput(props) }));
    const inputProps = Object.assign(Object.assign(Object.assign(Object.assign({}, field), { onChange: undefined }), props), { error: !!meta.error || props.error, helperText: meta.error || props.helperText, onChangeText: helpers.setValue, 
        // Fix for https://github.com/BlueBaseJS/plugin-json-schema-components/issues/32
        // Needs to be investigated why this is happening
        onBlur: undefined });
    return react_1.default.createElement(BaseFormField, Object.assign({}, inputProps));
};
exports.FormTextInput = FormTextInput;
exports.FormTextInput.defaultProps = {
    MainComponent: components_1.TextInput,
};
exports.FormTextInput.displayName = 'FormTextInput';
